/* eslint-disable react/destructuring-assignment */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FaChevronDown as ChevronDown } from 'react-icons/fa';
import { Wrapper, RedAster, Input } from './styled';
import './styles.scss';
import DataContainer from './components/DataContainer';
import colors from 'Styles/colors';

const InputFilter = ({
  value = '',
  getObjects,
  onChange,
  cleanOnSelect,
  onSelect,
  type = 'text',
  data,
  placeholder = 'Enter value',
  id,
  required = false,
  customStyles = false,
  fullWidth,
  renderItem = null,
  disabled = false
}) => {
  const [inputValue, setValue] = useState(value);
  const [showData, setShowData] = useState(false);

  const filteredData = data.filter(
    (item) =>
      inputValue === '' ||
      item.name.toLowerCase().includes(inputValue.toLowerCase())
  );

  useEffect(() => {
    getObjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeHandler = (v) => {
    setValue(v);
    setShowData(true);
    onChange('name', v);
  };

  const onSelectHandler = (item) => {
    if (cleanOnSelect) setValue('');
    else setValue(item.name);

    setShowData(false);
    onSelect(item);
  };

  return (
    <Wrapper
      onBlur={ () => {
        setShowData(false);
      } }
    >
      <Input
        id={ id }
        value={ inputValue }
        placeholder={ placeholder }
        type={ type }
        onChange={ (e) => onChangeHandler(e.target.value) }
        autoComplete="off"
        disabled={ disabled }
      />
      {required ? <RedAster>*</RedAster> : null}
      <ChevronDown
        color={ colors.grey71 }
        className="input-filter-arrow"
        onClick={ () => {
          if (disabled) return;
          setShowData(!showData);
        } }
      />
      {filteredData.length > 0 && showData && (
        <DataContainer
          filteredData={ filteredData }
          onSelectHandler={ onSelectHandler }
          customStyles={ customStyles }
          fullWidth={ fullWidth }
          renderItem={ renderItem }
        />
      )}
    </Wrapper>
  );
};

InputFilter.propTypes = {
  data: PropTypes.array.isRequired,
  getObjects: PropTypes.func.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  value: PropTypes.string,
  customStyles: PropTypes.bool,
  renderItem: PropTypes.func,
  disabled: PropTypes.bool
};

export default InputFilter;
